import React, { useState, useEffect, useContext, useRef } from "react";
import Cart from "./Cart.js";
import ItemList from "./ItemList.js";
import Upload from "./Upload.js";
import "./css/Products.css";
import Button from "react-bootstrap/Button";
import AddToCart from "./AddToCart";
import { CartProvider } from "../context/CartContext";
import { ProductContext } from "../context/ProductContext";
import Slider from "./Slider.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowCircleUp,
  faInfoCircle,
  faSearch,
  faUndoAlt,
} from "@fortawesome/free-solid-svg-icons";
import { LoginContext } from "../context/LoginContext.js";
import useTheme from "./useTheme.js";
import Comments from "./Comments.js";
import ReactPaginate from "react-paginate";
import Price from "./Price.js";

const GetKala = (props) => {
  const kalaRef = useRef([]);

  const [searchInput, setSearchInput] = useState("");

  const [search, setSearch] = useState("");

  const [scrollTop, setScrollTop] = useState(false);

  const [category, setCategory] = useState([]);

  const [selectCategory, setSelectCategory] = useState("");

  const [searchArray, setSearchArray] = useState([{}]);

  const [productItem, setProductItem] = useContext(ProductContext);

  const [goldPrice, setGoldPrice] = useState(0);

  const [dolarPrice, setDolarPrice] = useState(0);

  const [sekkePrice, setSekkePrice] = useState({});

  const [sort, setSort] = useState("");

  const [sortType, setSortType] = useState("desc");

  const loginContext = useContext(LoginContext);

  const [product, setProduct] = useState({
    end: 10,
    product: [],
    hasMore: true,
  });

  const [isLoading, setIsLoading] = useState(true);

  const [theme, switchTheme] = useTheme();

  const [page, setPage] = useState(0);

  const [pageNumber, setPageNumber] = useState(0);

  const [totalProduct, setTotalProduct] = useState(0);

  window.onscroll = function () {
    scrollFunction();
  };

  function scrollFunction() {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      setScrollTop(true);
    } else {
      setScrollTop(false);
    }
  }
  // When the user clicks on the button, scroll to the top of the document
  const topFunction = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  const returnFunction = () => {
    // window.location.replace("http://pmtala.com/");
    window.open("http://pmtala.com/#" + props.id, "_self");
  };

  useEffect(() => {
    const formData = new FormData();
    formData.append("getCategory", 1);
    formData.append("vitrinCode", props.id);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.result && data.data.length > 0) {
          const array = [];
          data.data.map((item) => {
            if (item.madar !== "") {
              array.push(item.madar);
            }
          });
          setCategory(array);
          console.log(category);
        }
      })
      .catch((e) => console.log(e));
  }, [props]);

  useEffect(() => {
    const formData = new FormData();
    if (
      loginContext.userInfo.dastresi === "1" ||
      loginContext.userInfo.dastresi === "3" ||
      loginContext.userInfo.dastresi === "5"
    ) {
      formData.append("isPv", 1);
    } else {
      formData.append("isPv", 0);
    }
    formData.append("getKalaNum", 1);
    formData.append("vitrinCode", props.id);
    formData.append("search", search);
    formData.append("category", selectCategory);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setPageNumber(Math.ceil(parseInt(data.data) / 24));
        setTotalProduct(parseInt(data.data));
      })
      .catch((e) => console.log(e));
  }, [props, search, selectCategory]);

  useEffect(() => {
    if (props.kala > 0) {
      const formData = new FormData();
      if (
        loginContext.userInfo.dastresi === "1" ||
        loginContext.userInfo.dastresi === "3" ||
        loginContext.userInfo.dastresi === "5"
      ) {
        formData.append("pv", 1);
      } else {
        formData.append("pv", 0);
      }
      formData.append("getKalaPage", 1);
      formData.append("vitrinCode", props.id);
      formData.append("kala", props.kala);
      const myRequest = new Request(
        "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
        {
          method: "POST",
          body: formData,
        }
      );
      fetch(myRequest)
        .then((res) => res.json())
        .then((data) => {
          setPage(parseInt(data.data));
        })
        .catch((e) => console.log(e));
    }
  }, [props]);

  useEffect(() => {
    setTimeout(() => {
      const formData = new FormData();
      if (sort !== "") {
        if (sortType === "desc") {
          formData.append("orderBy", sort + " " + "DESC");
        } else {
          formData.append("orderBy", sort);
        }
      } else {
        formData.append("orderBy", "");
      }

      if (
        loginContext.userInfo.dastresi === "1" ||
        loginContext.userInfo.dastresi === "3" ||
        loginContext.userInfo.dastresi === "5"
      ) {
        formData.append("isPv", 1);
      } else {
        formData.append("isPv", 0);
      }
      formData.append("get_kala_bonakdari", 1);
      formData.append("is_visitor", props.isVisitor);
      formData.append("id", props.id);
      formData.append("page", page);
      formData.append("search", search);
      formData.append("category", selectCategory);
      console.log(formData);
      const req = new Request(
        "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
        {
          method: "POST",
          body: formData,
        }
      );
      fetch(req)
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if (data.result === true && data.data != null) {
            setProductItem(data.data);
          } else {
            setProductItem(null);
          }
        })
        .catch((e) => {
          setProductItem(null);
          console.log(e);
        });
    }, 2000);

    const form = new FormData();
    form.append("get_cost_online", 1);
    const requ = new Request(
      "https://hamrahvitrin.ir/LiveGallery/dataProcess.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(requ)
      .then((res) => res.json())
      .then((data) => {
        setGoldPrice(data.result.geram18.ask);
        setDolarPrice(data.result.dolar.ask);
        const obj = {
          sekkeJadid: data.result["sekke-jad"].ask,
          sekkeGhadim: data.result["sekke-gad"].ask,
          sekkeNim: data.result["sekke-nim"].ask,
          sekkeRob: data.result["sekke-rob"].ask,
          sekkeGerami: data.result["sekke-grm"].ask,
        };
        setSekkePrice(obj);
        // setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        // setIsLoading(false);
      });
  }, [props, loginContext, page, search, selectCategory, sort, sortType]);

  useEffect(() => {
    if (productItem !== null) {
      if (productItem.length > 0) {
        setIsLoading(false);
      }
    }
    if (
      props.kala > 0 &&
      productItem.length > 0 &&
      kalaRef.current.length > 0
    ) {
      kalaRef.current = kalaRef.current.slice(0, productItem.length);
      let refFocus = 0;
      productItem.map((item, index) => {
        if (props.kala === item.barcodeKar) {
          refFocus = index;
        }
      });
      if (kalaRef.current[refFocus] !== null) {
        kalaRef.current[refFocus].scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [productItem, props.kala, kalaRef.current, page]);

  const setSearchValue = (e) => {
    if (e.target.value.includes("ك")) {
      const val = e.target.value.replace("ك", "ک");
      setSearchInput(val);
      return;
    }
    if (e.target.value.includes("ي")) {
      const val = e.target.value.replace("ي", "ی");
      setSearchInput(val);
      return;
    }
    setSearchInput(e.target.value);
  };

  const searchHandle = () => {
    if (page != 0) {
      setPage(0);
    }
    setSearch((pre) => {
      if (pre == searchInput) {
        return pre;
      } else {
        setIsLoading(true);
        return searchInput;
      }
    });
  };

  const filterItem = (sort) => {
    let array;
    if (sort) {
      array = productItem.sort((a, b) => {
        const darsadA = parseFloat(a.darsad.split("%")[0]);
        const darsadB = parseFloat(b.darsad.split("%")[0]);
        if (darsadA >= darsadB) {
          return -1;
        } else if (darsadB > darsadA) {
          return 1;
        } else {
          return 0;
        }
      });
      setProductItem(array);
    } else {
      array = productItem.filter((item) => {
        if (selectCategory !== "not" && selectCategory !== "") {
          return (
            item.kalaName.includes(searchInput) && item.madar === selectCategory
          );
        }
        return item.kalaName.includes(searchInput);
      });
    }

    if (array[0] !== undefined) {
      setProduct({
        end: 10,
        product: array.slice(0, 10),
        hasMore: true,
      });
    } else {
      setProduct({
        end: 10,
        product: array.slice(0, 10),
        hasMore: false,
      });
    }
    if (
      searchInput === "" &&
      (selectCategory === "not" || selectCategory === "")
    ) {
      return;
    }
    setSearchArray(array);
    setSearchInput("");
  };

  const enterHandle = (event) => {
    if (event.key === "Enter") {
      searchHandle();
    }
  };

  const handleSort = (e) => {
    setSort(e.target.value);
  };

  const handleSortType = (e) => {
    setSortType(e.target.value);
  };

  const handleCategory = (event) => {
    if (page != 0) {
      setPage(0);
    }
    setSelectCategory(event);
    setIsLoading(true);
  };

  const info = (link) => {
    window.open(link);
  };

  const handlePageClick = (e) => {
    setPage(parseInt(e.selected));
    setIsLoading(true);
  };

  const getCategoryImg = (item) => {
    let name = "";
    switch (item) {
      case "النگو": {
        name = "Alangoo.png";
        break;
      }
      case "انگشتر": {
        name = "Angoshtar.png";
        break;
      }
      case "آویز": {
        name = "Aviz.png";
        break;
      }
      case "دستبند": {
        name = "Dastband.png";
        break;
      }
      case "گردنبند": {
        name = "GardanBand.png";
        break;
      }
      case "گوشواره": {
        name = "Gooshvare.png";
        break;
      }
      case "حلقه": {
        name = "Halghe.png";
        break;
      }
      case "کودک کادوئی": {
        name = "Koodak.png";
        break;
      }
      case "مدال": {
        name = "Medal.png";
        break;
      }
      case "نیم ست": {
        name = "NimSet.png";
        break;
      }
      case "پابند": {
        name = "Paband.png";
        break;
      }
      case "رولباسی": {
        name = "RooLebasi.png";
        break;
      }
      case "ساعت": {
        name = "Saat.png";
        break;
      }
      case "سکه": {
        name = "Sekke.png";
        break;
      }
      case "سرویس": {
        name = "Servis.png";
        break;
      }
      case "زنجیر": {
        name = "Zanjir.png";
        break;
      }
      case "متفرقه": {
        name = "Motefareghe.png";
        break;
      }
      case "نام (لیزر)": {
        name = "Lazer.png";
        break;
      }
      default: {
        name = "Else.png";
        break;
      }
    }
    let logo = "";
    if (name !== "") {
      logo = require("../img/" + name);
    } else {
      logo = "";
    }
    return logo;
  };

  return (
    <div>
      <CartProvider>
        <Cart id={props.id} isVisitor={props.isVisitor} />
        {scrollTop ? (
          <FontAwesomeIcon
            icon={faArrowCircleUp}
            size={"2x"}
            className="scrollTopBtn"
            onClick={topFunction}
          />
        ) : null}
        {parseInt(props.isReturn) === 1 ? (
          <FontAwesomeIcon
            icon={faUndoAlt}
            size={"2x"}
            className="returnBtn"
            onClick={returnFunction}
          />
        ) : null}
        <div>
          <div className="row d-flex justify-content-center ">
            <div className="col-lg-6 col-md-6 col-sm-12 mt-4 form-row d-flex justify-content-center">
              <input
                dir="rtl"
                placeholder="جستجو"
                className="col-10 form-control rounded-input"
                value={searchInput}
                onChange={setSearchValue}
                onKeyDown={enterHandle}
              ></input>
              <div className="col-2">
                <Button
                  variant="primary"
                  className="search-btn"
                  onClick={() => searchHandle()}
                >
                  <FontAwesomeIcon icon={faSearch} />
                </Button>
              </div>
            </div>
            <div className="form-row col-lg-6 col-md-6 col-sm-12 mt-4 rtl d-flex justify-content-center">
              <select
                className="col-5 custom-select rtl rounded-input ml-2"
                value={sort}
                onChange={handleSort}
              >
                <option value={""}>پیش فرض</option>
                <option value={"barcodeKar"}>کد</option>
                <option value={"kalaName"}>الفبا</option>
                <option value={"vazn"}>وزن</option>
                <option value={"ojratBonak"}>اجرت</option>
                <option value={"date"}>تاریخ</option>
                <option value={"GROUPSORT"}>گروه بندی</option>
              </select>
              <select
                className="col-5 rtl rounded-input mr-2"
                value={sortType}
                onChange={handleSortType}
              >
                <option value={"desc"}>نزولی</option>
                <option value={"asc"}>صعودی</option>
              </select>
            </div>
          </div>

          <div className="row text-center my-3">
            {category.map((item, index) => (
              <div className="col col-md-3 col-lg-2" key={index}>
                <div className="py-4">
                  <div className={
                    theme === "light"
                      ? "card shadow  category-card-title"
                      : "card shadow  category-card-title bg-dark"
                  } onClick={() => { handleCategory(item) }}>
                    <div className="card-img-top">
                      <img
                        className="my-img cursor py-2 category-img"
                        src={getCategoryImg(item)}
                        alt={item}
                      />
                    </div>
                    <div
                      className={
                        theme === "light"
                          ? "p-1"
                          : "p-1 text-white"
                      }
                    >
                      <h6 className="cursor mt-1">{item}</h6>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row justify-content-center rtl mt-4">
            <h5>
              <span
                className={
                  theme === "light"
                    ? "badge bg-light text-dark p-3 category-card"
                    : "badge bg-dark text-light p-3 category-card"
                }
              >
                {productItem !== null && !isLoading
                  ? totalProduct + "مورد یافت شد "
                  : null}
              </span>
            </h5>
          </div>

          <div className="overflow">
            {!isLoading ? (
              <>
                {productItem !== null && productItem[0] !== undefined ? (
                  <div className="row products">
                    {productItem.map((product, i) => {
                      if (
                        props.id === 750040 &&
                        parseInt(product.barcodeKar) > 10000
                      ) {
                        return null;
                      } else {
                        return (
                          <div
                            key={product.pk}
                            ref={(el) => (kalaRef.current[i] = el)}
                            className="col-lg-4 col-md-6 mb-4"
                          >
                            <div className={
                              theme === "light"
                                ? "card h-100 shadow card-border"
                                : "card h-100 shadow card-border bg-dark text-white"
                            }>
                              <div className="card-img-top card-border">
                                <Slider
                                  // img_1={product.img_1}
                                  // img_2={product.img_2}
                                  // img_3={product.img_3}
                                  // img_4={product.img_4}
                                  type={"products"}
                                  images={product.images}
                                  num={product.img_num}
                                  barcode={product.barcode}
                                  vitrinCode={props.id}
                                />
                              </div>
                              <div className="card-body">
                                <Price
                                  product={product}
                                  setProductItem={setProductItem}
                                  gold={goldPrice}
                                  dolar={dolarPrice}
                                  sekke={sekkePrice}
                                  vitrinCode={props.id}
                                  type={"bar"}
                                />
                                <h5
                                  className="card-title cursor"
                                  onClick={() => {
                                    window.open(
                                      "https://hamrahvitrin.ir/bonak/?v=" +
                                      props.id +
                                      "&kala=" +
                                      product.pk,
                                      "_self"
                                    );
                                  }}
                                >
                                  {product.kalaName}
                                </h5>
                                {product.tozihat !== null &&
                                  product.tozihat.trim() !== "" ? (
                                  <h6 className="card-title text-warning">
                                    {product.tozihat}
                                  </h6>
                                ) : null}
                                <h6>کد : {product.barcodeKar}</h6>
                                {parseFloat(product.darsad_takhfif) > 0 ? (
                                  <h6>
                                    تخفیف کالا :{" "}
                                    {parseFloat(product.darsad_takhfif) + "%"}
                                  </h6>
                                ) : null}
                                {product.mark.trim() !== "" &&
                                  product.mark.trim() !== "0" ? (
                                  <h6>برند : {product.mark}</h6>
                                ) : null}
                                {product.type === "0" ||
                                  product.type === "2" ||
                                  product.type === "3" ? (
                                  <h6>
                                    {parseFloat(product.vazn) !== 0
                                      ? "وزن تقریبی : " + product.vazn
                                      : null}
                                  </h6>
                                ) : (
                                  <h6>
                                    {parseFloat(product.vazn) !== 0
                                      ? "وزن : " + product.vazn
                                      : null}
                                  </h6>
                                )}
                                <Price
                                  product={product}
                                  setProductItem={setProductItem}
                                  gold={goldPrice}
                                  dolar={dolarPrice}
                                  sekke={sekkePrice}
                                  vitrinCode={props.id}
                                />
                                <AddToCart product={product} />
                                <ItemList pk={product.pk} />
                                <div className="row">
                                  {product.link.trim() !== "" ? (
                                    <div className="col-3 mt-3">
                                      <FontAwesomeIcon
                                        icon={faInfoCircle}
                                        size="2x"
                                        color="#5bc0de"
                                        onClick={() => info(product.link)}
                                      />
                                    </div>
                                  ) : (
                                    <div className="col-3"></div>
                                  )}
                                  <div className="col-6">
                                    <Upload
                                      barcode={product.barcode}
                                      vitrinCode={props.id}
                                      type={"productImage"}
                                      vitrinImg={product.vitrinCode}
                                    />
                                  </div>
                                  <div className="col-3 mt-3">
                                    <Comments
                                      pk={product.pk}
                                      barcode={product.barcode}
                                      vitrinCode={props.id}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>
                ) : (
                  <div className="mt-4 row justify-content-center">
                    محصولی یافت نشد
                  </div>
                )}
              </>
            ) : (
              <div className="row justify-content-center m-5 p-5">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </CartProvider >
      <div className="row justify-content-center">
        <ReactPaginate
          previousLabel={"<"}
          nextLabel={">"}
          breakLabel={"..."}
          pageCount={pageNumber}
          marginPagesDisplayed={1}
          pageRangeDisplayed={3}
          forcePage={page}
          onPageChange={handlePageClick}
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination my-5"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
        />
      </div>
    </div >
  );
};

export default GetKala;
